import { render, staticRenderFns } from "./terms_of_use_link.vue?vue&type=template&id=7b9d58c7&"
import script from "./terms_of_use_link.vue?vue&type=script&lang=js&"
export * from "./terms_of_use_link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b9d58c7')) {
      api.createRecord('7b9d58c7', component.options)
    } else {
      api.reload('7b9d58c7', component.options)
    }
    module.hot.accept("./terms_of_use_link.vue?vue&type=template&id=7b9d58c7&", function () {
      api.rerender('7b9d58c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/administration/terms_of_use_link.vue"
export default component.exports